import { ITripSource, TripSourceAccountings } from "../../../..//TripSources"
import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"

export default function TransportServiceProviderAccountingsPage() {
	const { tripSource } = useOutletContext<{
		tripSource: ITripSource
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Accounting | B2B Source</title>
			</Helmet>
			<TripSourceAccountings tripSource={tripSource} />
		</>
	)
}
